// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const noctowl: PokeData = {
  "id": 164,
  "name": "noctowl",
  "height": 16,
  "weight": 408,
  "base_experience": 158,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "growl",
    "peck",
    "confusion",
    "hypnosis",
    "reflect",
    "dream-eater",
    "sky-attack",
    "foresight",
    "uproar",
    "extrasensory",
    "roost",
    "psycho-shift",
    "air-slash",
    "zen-headbutt",
    "synchronoise",
    "echoed-voice",
    "moonblast"
  ],
  "moves": [
    "tackle",
    "growl",
    "peck",
    "reflect",
    "sky-attack",
    "roost",
    "air-slash",
    "zen-headbutt",
    "moonblast",
    "purification",
    "acrobatics",
    "body-slam",
    "aerial-ace"
  ],
  "evolution_chain": {
    "id": 83,
    "item": null,
    "species": [
      {
        "name": "hoothoot",
        "order": 195,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "noctowl",
        "order": 196,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 163,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 115,
    "ability_power": 142
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
